import { useMemo } from 'react';
import dayjs from 'dayjs';

export function useDateRange(
  selectedPeriod: string,
  customDateRange?: [dayjs.Dayjs, dayjs.Dayjs] | null
) {
  return useMemo(() => {
    const today = dayjs().startOf('day');

    if (customDateRange && customDateRange[0] && customDateRange[1]) {
      return {
        fromDate: customDateRange[0].format('YYYY-MM-DD'),
        toDate: customDateRange[1].format('YYYY-MM-DD'),
      };
    }

    switch (selectedPeriod) {
      case 'today':
        return {
          fromDate: today.format('YYYY-MM-DD'),
          toDate: today.format('YYYY-MM-DD'),
        };
      case 'week': {
        // dayjs startOf('week') is Sunday; we want Monday as start
        const weekStart = today.day() === 0
          ? today.subtract(6, 'day') // Sunday → previous Monday
          : today.startOf('week').add(1, 'day'); // Mon-Sat → this Monday
        return {
          fromDate: weekStart.format('YYYY-MM-DD'),
          toDate: today.format('YYYY-MM-DD'),
        };
      }
      case 'month': {
        const monthStart = today.startOf('month');
        return {
          fromDate: monthStart.format('YYYY-MM-DD'),
          toDate: today.format('YYYY-MM-DD'),
        };
      }
      case 'custom':
        return { fromDate: '', toDate: '' };
      default:
        return {
          fromDate: today.format('YYYY-MM-DD'),
          toDate: today.format('YYYY-MM-DD'),
        };
    }
  }, [selectedPeriod, customDateRange]);
}
